import type { ProAdminRefundDecisionDto, ProAdminRefundDecisionInput } from "@dutyon/apis";

export function prepareRejection(reason: string, revision: number): ProAdminRefundDecisionInput {
  const normalized = reason.trim();
  if (
    !Number.isSafeInteger(revision) ||
    revision < 0 ||
    revision >= 2147483647 ||
    !normalized ||
    normalized.length > 1000 ||
    Array.from(normalized).some((c) => {
      const code = c.charCodeAt(0);
      return (code < 32 && ![9, 10, 13].includes(code)) || code === 127;
    })
  )
    throw new Error("반려 사유를 1~1,000자로 입력하고 최신 요청을 확인해 주세요.");
  return { expectedRevision: revision, reason: normalized };
}
export function readRejection(
  value: unknown,
  id: string,
  input: ProAdminRefundDecisionInput,
): ProAdminRefundDecisionDto {
  if (!value || typeof value !== "object" || Array.isArray(value))
    throw new Error("반려 결과를 확인하지 못했습니다.");
  const data = value as ProAdminRefundDecisionDto;
  if (
    typeof data.id !== "string" ||
    !/^[A-Za-z0-9_-]{1,128}$/.test(data.id) ||
    data.requestId !== id ||
    data.status !== "REJECTED" ||
    data.revision !== input.expectedRevision + 1 ||
    data.reason !== input.reason ||
    typeof data.decidedAt !== "string" ||
    !Number.isFinite(Date.parse(data.decidedAt)) ||
    new Date(data.decidedAt).toISOString() !== data.decidedAt
  )
    throw new Error("반려 결과를 확인하지 못했습니다.");
  return data;
}
